export { loadable } from './lib/tapestry-lazy-load';
